/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One rule in the built-in exclusion library. Deliberately omits internal detection-engine identifiers (sources, rule ids) so they are not exposed to end users.
 */
export type BuiltinExclusionEntry = {
  /**
   * Human rationale for why these values are known-safe.
   */
  description: string;
  /**
   * Stable rule id.
   */
  id: string;
  /**
   * Label surfaced when this rule suppresses a finding.
   */
  reason: string;
  /**
   * Example values — published test/documentation data, never real secrets.
   */
  samples?: Array<string> | undefined;
};

/** @internal */
export const BuiltinExclusionEntry$inboundSchema: z.ZodMiniType<
  BuiltinExclusionEntry,
  unknown
> = z.object({
  description: z.string(),
  id: z.string(),
  reason: z.string(),
  samples: z.optional(z.array(z.string())),
});

export function builtinExclusionEntryFromJSON(
  jsonString: string,
): SafeParseResult<BuiltinExclusionEntry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BuiltinExclusionEntry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BuiltinExclusionEntry' from JSON`,
  );
}
